import React from "react";
import {
	makeStyles,
	Typography,
	// useTheme,
} from "@material-ui/core";
import { useTableOverviewContext } from "./WhitePopup";

const useStyles = makeStyles((theme) => ({
	root: {},
	lightSecondary: {
		color: "rgba(0, 0, 0, 0.54)",
	},
}));

interface WhitePopupContentProps {
	children: any;
	color?:
		| "initial"
		| "inherit"
		| "primary"
		| "secondary"
		| "textPrimary"
		| "textSecondary"
		| "error";
}
const WhitePopupContent: React.FC<WhitePopupContentProps> = ({
	children,
	color,
}) => {
	const classes = useStyles();
	// const theme = useTheme();void
	const { variant } = useTableOverviewContext();

	return (
		<div className={classes.root}>
			<Typography
				variant="body2"
				align={variant === "confirmation" ? "left" : "center"}
				style={{
					color: variant === "response" ? "black" : "#9E9E9E",
				}}
				color="textPrimary">
				{children}
			</Typography>
		</div>
	);
};

export default WhitePopupContent;
